<template>
    <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg modal-fullscreen-lg-down"
        >
            <div class="modal-content">
                <div class="modal-header bg-primary text-light">
                    <h5 class="modal-title" id="staticBackdropLabel">
                        Carga Masiva con Archivo
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body">
                    <div v-if="empresas.length > 0" class="col-12">
                        <div class="form-group d-lg-flex align-items-center">
                            <label class="form-label col-auto mb-0" for="empresa">Seleccionar empresa</label>
                            <select
                                name="empresa"
                                id="empresa"
                                class="form-control"
                                v-model="dropzoneOptions.url"
                                @change="changeUrl"
                            >
                                <option value="">
                                    Seleccionar empresa para la carga masiva
                                </option>
                                <option
                                    v-for="(client, index) of empresas"
                                    :key="index"
                                    :value="client.url"
                                >
                                    {{ client.client }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <vue-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        :useCustomSlot="true"
                        v-on:vdropzone-success="fileCharged"
                        v-on:vdropzone-error="fileError"
                    >
                        <div class="dropzone-custom-content">
                            <h3 class="text-primary">
                                <i
                                    class="zmdi zmdi-cloud-upload"
                                    style="font-size: 32px"
                                ></i>
                            </h3>
                            <h3 class="text-center">
                                ¡Arrastra y suelta para subir el archivo CSV de
                                los Cursos
                            </h3>
                            <div class="text-center">
                                ...o haga clic para seleccionar un archivo de su
                                computadora
                            </div>
                        </div>
                    </vue-dropzone>
                </div>
                <div class="modal-footer">
                    <a href="/templates/template_carga_de_cursos_masivos.csv" download target="_blank" style="color: #fff" class="btn btn-secondary">
                        Descargar archivo de muestra
                    </a>
                    <button
                        style="color: #fff"
                        type="button"
                        class="btn btn-utel btn-inverted"
                        data-bs-dismiss="modal"
                    >
                        Salir
                    </button>
                </div>
            </div>
        </div>

        <!-- Button trigger modal -->
        <button id="succesCreationBtn" type="button" class="btn btn-primary invisible" data-bs-toggle="modal" data-bs-target="#succesCreation">
        </button>

        <!-- Modal -->
        <div class="modal fade" id="succesCreation" tabindex="-1" aria-labelledby="succesCreationLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="succesCreationLabel">Carga masiva</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="text-center">
                            Carga masiva<br>realizada correctamente.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-light" data-bs-dismiss="modal">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
    components: {
        vueDropzone: vue2Dropzone,
    },
    props: ["token", "url", "empresas"],
    mounted() {
        this.openModal();
    },
    data() {
        return {
            dropzoneOptions: {
                url: this.url,
                addRemoveLinks: true,
                thumbnailWidth: 150,
                resizeWidth: 1024,
                capture: true,
                uploadMultiple: false,
                maxFiles: 1,
                acceptedFiles: "text/csv",
                headers: { "X-CSRF-TOKEN": "" + this.token + "" },
            },
            fileType: "",
            error: [],
            modal: [],
        };
    },
    methods: {
        fileCharged(file, res) {
            console.log(res);
            if (typeof res == "object") {
                this.$swal(res.message);
            } else {
                this.$swal(res);
            }
        },
        fileError(file, res) {
            if (typeof res == "object") {
                this.$swal(res.message);
            } else {
                this.$swal(res);
            }

            this.$refs.myVueDropzone.removeFile(file);
        },
        changeUrl(e) {
            console.log(this.dropzoneOptions.url);
            this.$refs.myVueDropzone.options.url = e.target.value;
            this.$refs.myVueDropzone.dropzone.options.url = e.target.value;
        },
        openModal() {
            let params = location.search;
            let search = new URLSearchParams(params);
            let btn = document.getElementById("OpenModalButton");
            if (search.has("openModal")) btn.click();
        },
    },
};
</script>
